export const GET_SERVICE_PROVIDERS_LIST = null;
export const SELECTED_SERVICE_PROVIDER_ID = null;
export const SELECTED_ORGANIZATION_ID = null;
export const GET_SERVICE_PROVIDER_SERVICES_LIST = null;
export const GET_STAFF_MEMBERS_LIST_BY_SERVICE_PROVIDER_ID = null;
export const GET_SERVICE_PROVIDER_OFFERS_LIST = null;
export const GET_SERVICE_PROVIDER_PACKAGES_LIST = null;